import blankAction from '../assets/images/bbBlankAction.png'
import getAction from './getAction'
import getCombatantSlots from './getCombatantSlots'

export default async function getCombatantPreviousRoundActionImage(combatant, round) {
  if (!combatant?.slug || !Number.isFinite(round) || round <= 1) {
    return ''
  }

  const slots = await getCombatantSlots(combatant.slug)
  const previousRound = round - 1
  const actions = Array.isArray(slots?.actions) ? slots.actions : []

  const previousRoundAction = actions
    .filter(
      (action) =>
        action?.round === previousRound &&
        Number.isFinite(action?.number) &&
        action?.action_name !== 'pending' &&
        action?.action_name !== 'blank' &&
        getAction(action?.action_name)?.actual !== false,
    )
    .sort((left, right) => right.number - left.number)[0]

  return previousRoundAction?.action_image || blankAction
}
